import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';

import { Metamodel } from 'app/model/base/model';
import { ShopifyObjectDataset } from 'app/model/dataset/shopify.dataset';
import { TabularTypeDatasetAdapter, tabularTypeDatasetAdapts } from './tabular-type.dataset.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(ShopifyObjectDataset),
    asynchronous: true,
    adapts: tabularTypeDatasetAdapts
})
export class ShopifyObjectDatasetAdapter extends TabularTypeDatasetAdapter<ShopifyObjectDataset, Model.DatasetResource> {
    protected async _toResource(dataset: ShopifyObjectDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, Metamodel.modelFor(ShopifyObjectDataset).name);
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: ShopifyObjectDataset): Promise<ShopifyObjectDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset, ShopifyObjectDataset.MODEL);
    }
}
